import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { Grid, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import Typo from '../../components/CustomTypo';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { ReNewIcon, DateRangeBlackIcon } from '../../components/icons';
import ButtonCustom from '../../components/ButtonCustom';
import { formatDateToDDMMYYYYFrEpoch, getCurrencySymbol, mappingState, subscriptionState } from '../../utils/util';
import { custom_assets, domainName, portal_config } from '../../../portal.config';
import { portalCfg } from '../../../portal.router.config';
import { Currencies } from '../../../Currencies';

var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";

const styles = theme => ({
    container: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 3, 2, 3),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2, 1, 2),
        },
    },
    item: {
        border: '1px solid ' + theme.palette.background.light,
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        //height: 280,
        backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        padding: '15px 10px'
    },
    sub_img: {
        display: 'flex',
        alignItems: 'center'
    },
    item_cover: {
        border: '1px solid ' + theme.palette.border.secondary,
        borderRadius: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginLeft: theme.spacing(1),
        "& img": {
            width: theme.spacing(10),
            height: theme.spacing(10),
            padding: theme.spacing(0.5),
        }
    },
    status: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    sub_date: {
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // height: 100
    },
    devices: {
        padding: '15px 10px'
    },
    item_device: {
        padding: theme.spacing(3),
        border: "1px solid " + theme.palette.border.secondary,
        borderRadius: theme.spacing(3),
        marginTop: theme.spacing(2)
    }
});

function SubcriptionItem(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const { classes, t, item, currency } = props;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    // console.log("AAA item sub===", item);
    let images = dataUtil.getImageByUsageType(item.service.product ? item.service.product.creatives : null, usage_type.product_item);
    // console.log("AAA image sub===", images);
    let imageSub = path + '/images/logo.png';
    if (images && images.length > 0) {
        imageSub = images[0].uri;
    }
    let currency_symbol = currency;
    if(item.service && item.service.price){
        currency_symbol = getCurrencySymbol(item.service.price.currency ? item.service.price.currency : null);
    }
    return (
        <Grid xs={12} sm={6} md={6} lg={5} xl={4} item container className={classes.container}>
            <Grid xs={12} item className={classes.item}>
                <Grid item container style={{ alignItems: "center" }}>
                    <Grid item xs={9}>
                        <Grid item xs={12} className={classes.sub_img}>
                            <Grid item className={classes.item_cover}>
                                <img src={imageSub} alt="Image Service" />
                            </Grid>
                            <Typo variant='subtitle2' style={{ marginLeft: 10 }}>{item.service && item.service.product ? item.service.product.name : ""}</Typo>
                        </Grid>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: 'right' }}>
                        <Typo variant='subtitle2' style={{ marginLeft: 10 }}>{currency_symbol}{item.service.price ? item.service.price.price.toFixed(2) : "0.00"}</Typo>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.status}>
                    <ButtonCustom size="xs" color={mappingStateBage(item.service.life_cycle_state)}>{mappingState(item.service.life_cycle_state, t).toUpperCase()}</ButtonCustom>
                    {item.service && item.service.paused_period && item.service.paused_period.start_date && item.service.paused_period.end_date && <Typo>
                        {formatDateToDDMMYYYYFrEpoch(item.service.paused_period.start_date, true)} - {formatDateToDDMMYYYYFrEpoch(item.service.paused_period.end_date, true)}
                        </Typo>}
                    {item.service.terms && item.service.terms.in_contract &&
                        <ButtonCustom size="xs" color={"info"}>{t('in_contract')}</ButtonCustom>}
                    {item.service.terms && !item.service.terms.in_contract && item.service.terms.contract_period == null && 
                            <ButtonCustom size="xs" color={"info"}>{t('no_contract')}</ButtonCustom>}

                    {item.service.trial_period && item.service.trial_period.trial_state == "IN_TRIAL" &&
                        <ButtonCustom size="xs" color={"info"}>{t('in_trial')}</ButtonCustom>}
                    {domainName == 'airlink' && item.service.is_recurring_charge && <ButtonCustom size="xs" color={"primary"}>{t('recurring_charge')}</ButtonCustom>}
                </Grid>
                <Grid item container className={classes.sub_date}>
                    {item.service.terms && item.service.terms.auto_renew &&
                        <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                            <ReNewIcon />
                            <Grid item style={{ paddingLeft: 10 }}>
                                <Typo variant='subtitle2'>{t('auto_renew')}</Typo>
                                <Typo variant='body2'>{item.service.terms.contract_period && item.service.terms.contract_period.end_date ? formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.end_date) : ''}</Typo>
                            </Grid>
                        </Grid>
                    }
                    {item.service.terms.in_contract
                        && item.service.terms.contract_period
                        && item.service.terms.contract_period.start_date
                        && item.service.terms.contract_period.end_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typo variant='subtitle2'> {t('sub_contract_period') + " "} </Typo>
                                    <Typo variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.end_date)}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {item.service.trial_period
                        && item.service.trial_period.end_date
                        && item.service.trial_period.start_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typo variant='subtitle2'>{t('sub_trial_period')}</Typo>
                                    <Typo variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.trial_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.trial_period.end_date)}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Grid>

                {domainName == 'airlink' && <Grid item xs={12} container justifyContent='center' alignItems='center'>
                    <Grid item xs={8}>
                        {item.service.added_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{t('added_on')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.added_on)}</Typo>
                            </Grid>
                        </Grid>}
                        {item.service.removed_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{t('removed_on')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.removed_on)}</Typo>
                            </Grid>
                        </Grid>}
                        {item.service.firts_activated_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typo variant='subtitle2'>{t('firts_activated_on')}:</Typo>
                                <Typo variant='body2' mg_left_sm>{formatDateToDDMMYYYYFrEpoch(item.service.firts_activated_on)}</Typo>
                            </Grid>
                        </Grid>}
                    </Grid>
                    <Grid item xs={4}>
                        <Grid item xs={12} style={{ justifyContent: 'flex-end' }}>
                            <ButtonCustom size="xs" color={"primary"} onClick={() => props.onRecurringPayment(item)}>{t('recurring_payment')}</ButtonCustom>
                        </Grid>
                    </Grid>
                </Grid>}
                {item.service && <ActionsMenu
                    t={t}
                    anchorEl={anchorEl}
                    item={item}
                    cards={props.cards}
                    handleClick={handleClick}
                    handleClose={handleClose}
                    onChangeService={props.onChangeService}
                    onConfirmActionsService={props.onConfirmActionsService}
                />}
                {/* {item.devices && item.devices.length > 0 && <Grid item xs={12} className={classes.devices}>
                    <Typo variant='h6'>{t('devices')}&nbsp;</Typo>
                    <Grid item xs={12} container>
                        {item.devices.map((service, index) => {
                            let product = service.device && service.device.product ? service.device.product : null;
                            return (
                                <Grid item xs={12} key={index}>
                                    <Grid xs={12} item className={classes.item_device}>
                                        <Grid item xs={12} style={{textAlign: 'right'}}>
                                            <ButtonCustom size="xs" color={service.state === 'DISABLED' ? 'info' : 'success'}>{service.state}</ButtonCustom>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typo>{t('device_id')}: <strong>{service.device && service.device.id ? service.device.id : null}</strong></Typo>
                                            <Typo>{t('product_name')}: <strong>{product && product.name ? product.name : null}</strong></Typo>
                                            <Typo>{t('serial_number')}: <strong>{service.device.serial_number ? service.device.serial_number : null}</strong></Typo>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>} */}
            </Grid>
        </Grid>
    );
}

function ActionsMenu(props) {
    const { t, classes, item, cards } = props;
    console.log("cards ===", cards);
    let showActivateService = false;
    if((item.service.life_cycle_state === subscriptionState.NOT_EFFECTIVE) || (item.service.life_cycle_state === subscriptionState.DRAFT && document._portalConfig.isCustomActivateService && cards && cards.length > 0))
    {
        showActivateService = true;
    }

    const StyledMenu = withStyles({
        paper: {
            border: '1px solid #d3d4d5',
        },
    })((props) => (
        <Menu
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            {...props}
        />
    ));

    const StyledMenuItem = withStyles((theme) => ({
        root: {
        },
    }))(MenuItem);

    return (
        <div style={{textAlign: 'right'}}>
            <ButtonCustom
                aria-controls="customized-menu"
                aria-haspopup="true"
                size="xs"
                onClick={props.handleClick}
                actions-service-id={item.service.id}
            >
                {t('btn_actions')}
            </ButtonCustom>
            <StyledMenu
                id="subscription-actions-menu"
                anchorEl={props.anchorEl}
                keepMounted
                open={Boolean(props.anchorEl)}
                onClose={props.handleClose}
            >
                {showActivateService && <StyledMenuItem
                    onClick={() => {
                        props.handleClose();
                        props.onConfirmActionsService('ACTIVATE', item);
                    }} id="btn_activate_service">
                    <ListItemText primary={t('btn_active')} />
                </StyledMenuItem>}
                {item.service.life_cycle_state === subscriptionState.EFFECTIVE && <StyledMenuItem
                    onClick={() => {
                        props.handleClose();
                        props.onChangeService(item);
                    }} id="btn_change_service">
                    <ListItemText primary={t('change_service')} />
                </StyledMenuItem>}
                {!portal_config[domainName].hidePauseService && (item.service.life_cycle_state === subscriptionState.NOT_EFFECTIVE || item.service.life_cycle_state === subscriptionState.EFFECTIVE) && <StyledMenuItem
                    onClick={() => {
                        props.handleClose();
                        props.onConfirmActionsService('PAUSE', item);
                    }} id="btn_pause_service">
                    <ListItemText primary={t('btn_pause')} />
                </StyledMenuItem>}
                <StyledMenuItem
                    onClick={() => {
                        props.handleClose();
                        props.onConfirmActionsService('CANCEL', item);
                    }} id="btn_cancel_service">
                    <ListItemText primary={t('btn_cancel')} />
                </StyledMenuItem>
                {!portal_config[domainName].hideResumeService && item.service.life_cycle_state === subscriptionState.PAUSED && <StyledMenuItem
                    onClick={() => {
                        props.handleClose();
                        props.onConfirmActionsService('RESUME', item);
                    }} id="btn_resume_service">
                    <ListItemText primary={t('btn_resume')} />
                </StyledMenuItem>}
            </StyledMenu>
        </div>
    );
}

function mappingStateBage(state){
    if(state === subscriptionState.EFFECTIVE || state === subscriptionState.ACTIVE){
        return "success";
    }else if(state === subscriptionState.NOT_EFFECTIVE || state === subscriptionState.CANCELLED){
        return "red";
    }else if(state === subscriptionState.PAUSED || state === subscriptionState.DRAFT){
        return "orange";
    }
}
export default withStyles(styles)(withTranslation()(SubcriptionItem));